"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizzlyApiClientLogger = void 0;
class VizzlyApiClientLogger {
    static setBackend(backend) {
        this.backend = backend;
    }
    static debug(...args) {
        if (VizzlyApiClientLogger.backend) {
            VizzlyApiClientLogger.backend.debug(...args);
        }
    }
    static info(...args) {
        if (VizzlyApiClientLogger.backend) {
            VizzlyApiClientLogger.backend.info(...args);
        }
    }
    static warning(...args) {
        if (VizzlyApiClientLogger.backend) {
            VizzlyApiClientLogger.backend.warning(...args);
        }
    }
    static error(...args) {
        if (VizzlyApiClientLogger.backend) {
            VizzlyApiClientLogger.backend.error(...args);
        }
    }
}
exports.VizzlyApiClientLogger = VizzlyApiClientLogger;
VizzlyApiClientLogger.UserAgentProduct = 'Vizzly-Api-Client';
